"use strict";

exports.__esModule = true;
exports.default = getTabTransitionComponent;
var _NoopTransition = _interopRequireDefault(require("@restart/ui/NoopTransition"));
var _Fade = _interopRequireDefault(require("./Fade"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getTabTransitionComponent(transition) {
  if (typeof transition === 'boolean') {
    return transition ? _Fade.default : _NoopTransition.default;
  }
  return transition;
}